export const TAX_STRUCTURE_OPTIONS = [
  { name: 'Not selected', value: null },
  { name: 'Tax exempt', value: 'none' },
  { name: 'Manual', value: 'manual' },
  { name: 'TaxJar', value: 'taxjar' }
]

const HINTS = {
  none: "No tax on this customer's orders",
  manual: 'Your manual tax rates apply',
  taxjar: 'TaxJar calculates the tax'
}

export const taxStructureName = value =>
  TAX_STRUCTURE_OPTIONS.find(option => option.value === value)?.name ?? 'Not selected'

export const taxStructureHint = value => HINTS[value] ?? "Follows each store's tax setting"
